import React from "react";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {ReactComponent as IconTrade} from "assets/img/icon/icon-trade.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {PrimaryButton} from "views/components/style";
import {Modal} from "@mui/material";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import {eq} from "lodash";
import styled from "@emotion/styled";
import {media} from "assets/css/media";
import type {IInfoTradeModalController} from "views/components/modals/info_trade_modal/info_trade_modal.controller";
import {Exist} from "views/components/exist/exist.component";

const ConfirmModalFooter = styled(ModalFooter)`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-top: 10px;

	.confirm_modal_btn {
		width: 220px;

		@media (max-width: ${media.mobile}) {
			width: 295px;
		}
	}
`;

export const InfoTradeModal: React.FC = observer(() => {
	const {i18n, visibleModal, close, isCurrentLineupHasPlayer, makeTrades} =
		useViewController<IInfoTradeModalController>(Bindings.InfoTradeModalController);

	const title = i18n.t("modal.info_trade.title", "Four-ball (PM) session is now open");
	const message = i18n.t(
		"modal.info_trade.description",
		"You have 3 trades to make changes to your team. Your team will lock at the start of the FOUR-BALL (PM) session. Hit the transfer icon to make changes."
	);

	const showPrompt = eq(ModalType.INFO_TRADE, visibleModal);

	if (!showPrompt) {
		return null;
	}

	return (
		<Modal open={showPrompt}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconTrade />
					</ModalHeader>
					<ModalBody>
						<ModalTitle style={{marginBottom: 25, marginTop: 15}}>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ConfirmModalFooter>
						<Exist when={isCurrentLineupHasPlayer}>
							<PrimaryButton
								onClick={makeTrades}
								size="large"
								className="confirm_modal_btn">
								{i18n.t("modal.info_trade.close_button", "Make trades")}
							</PrimaryButton>
						</Exist>
					</ConfirmModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
